export default __webpack_public_path__ + "static/media/tw.fd37c67c.svg";